import { defineMessages } from 'react-intl';

export default defineMessages({
  yAxisLabel: {
    defaultMessage: '# of New Orders each Day',
    id: 'Lk5gW3',
    description: 'label for y axis describing what the numbers signify',
  },
  shipped: {
    defaultMessage: 'Orders Shipped',
    id: '5TYLKd',
    description: 'new orders each day label used in legend',
  },
  unshipped: {
    defaultMessage: 'Orders Unshipped',
    id: 'Y9eX9g',
    description: 'new orders each day label used in legend',
  },
  orderChartTitle: {
    defaultMessage: 'Orders',
    id: 'vICwww',
    description: 'title for the new orders each day chart',
  },
});
